<!-- Loading -->
<div class="bd-placeholder" *ngIf="isLoading">
  <i class="fa fa-spinner fa-spin"></i>
  <span>Recherche...</span>
</div>

<!-- Empty -->
<div class="bd-placeholder" *ngIf="!isLoading && !isBeneficiaryDataComplete()">
  <i class="fa fa-user-circle"></i>
  <span>{{ searchAttempted ? 'Aucun résultat' : 'Recherchez un bénéficiaire' }}</span>
</div>

<!-- Result -->
<div class="bd-card" *ngIf="isBeneficiaryDataComplete()">

  <!-- Avatar -->
  <div class="bd-avatar">
    <img [src]="itemBeneficiare?.image_url || getPlaceholderImage()"
         (error)="onImageError($event)"
         (load)="onImageLoad()"
         [alt]="itemBeneficiare?.display_name || 'bénéficiaire'">
    <span class="bd-online-dot"
          [class.online]="itemBeneficiare?.is_online"
          [class.vip]="itemBeneficiare?.is_vip === 1">
    </span>
  </div>

  <!-- Info -->
  <div class="bd-info">
    <div class="bd-name-row">
      <span class="bd-name">
        {{ (itemBeneficiare?.prenom || '') + ' ' + (itemBeneficiare?.nom || '') | titlecase }}
      </span>
      <span class="bd-status"
            [class.active]="itemBeneficiare?.statut_libelle === 'ACTIF'"
            [class.inactive]="itemBeneficiare?.statut_libelle !== 'ACTIF'"
            *ngIf="itemBeneficiare?.statut_libelle">
        {{ itemBeneficiare.statut_libelle }}
      </span>
    </div>

    <div class="bd-chips">
      <span class="bd-chip" *ngIf="itemBeneficiare?.matricule">
        {{ itemBeneficiare.matricule }}
      </span>
      <span class="bd-chip" *ngIf="itemBeneficiare?.numero_cnam">
        {{ itemBeneficiare.numero_cnam }}
      </span>
      <span class="bd-chip accent" *ngIf="itemBeneficiare?.taux_applicable">
        {{ itemBeneficiare.taux_applicable }}%
      </span>
      <span class="bd-chip" *ngIf="itemBeneficiare?.age_detail">
        {{ itemBeneficiare.age_detail }}
      </span>
      <span class="bd-chip" *ngIf="itemBeneficiare?.police_libelle">
        {{ itemBeneficiare.police_libelle }}
      </span>
    </div>
  </div>

</div>

<!-- Hidden file input -->
<input #imageInput type="file" accept="image/*" (change)="onImageSelected($event)" style="display:none">
